<div class="col-sm-2">
  <div [innerHTML]="'adura.beurteilung.typ.' + beurteilung.type | translate"></div>
  <div [innerHTML]="beurteilung.date | date: 'dd.MM.yyyy'"></div>
</div>
<div class="col-sm-9 bullets" [innerHTML]="beurteilung.text"></div>
